<template>
  <b-card no-body>
    <b-card-header>
      <div>
        <b-card-title class="mb-1">
          {{ document.question }} -
          {{ $t(document.type == TYPES.DATE ? 'questionnaire.questionType.dateQuestion' : 'questionnaire.questionType.rangeQuestion') }}
        </b-card-title>
        <b-card-sub-title>
          {{ totalAnswers }} {{ $t('questionnaire.answers') }}
        </b-card-sub-title>
      </div>
      <div>
        <v-select
          v-model="dateItem"
          :options="dateOptions"
          :reduce="option => option.value"
          :clearable="false"
          class="text-capitalize"
          style="min-width: 150px"
        />
      </div>
    </b-card-header>
    <b-card-body>
      <vue-apex-charts
        type="bar"
        height="400"
        :options="chartOptions"
        :series="series"
        @dataPointSelection="dataPointSelection"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardBody,
  BCardHeader,
  BCardTitle,
  BCardSubTitle,
  VBModal,
} from 'bootstrap-vue'
import { TYPES, COLORS, MONTH_OPTIONS, THIS_YEAR } from '@/shared/constants'
import VueApexCharts from 'vue-apexcharts'
import moment from 'moment'
import vSelect from 'vue-select'
import { capitalize } from '@hw-core/utils'

export default {
  directives: {
    'b-modal': VBModal,
  },
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BCardSubTitle,
    BCardBody,

    VueApexCharts,
    vSelect,
  },
  props: {
    document: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      TYPES,
      MAX_AVATAR_NUMBER: 5,
      dateItem: MONTH_OPTIONS[(new Date()).getMonth()],
    }
  },
  computed: {
    dateOptions() {
      return [
        {
          value: THIS_YEAR,
          label: this.$t('questionnaire.thisYear'),
        },
        ...MONTH_OPTIONS.map(month => ({
          value: month,
          label: month,
        })),
      ]
    },
    selectedYear() {
      return this.dateItem === THIS_YEAR
    },
    dateAnswers() {
      return Object.keys(this.document.answers)
    },
    series() {
      const data = []
      if (this.selectedYear) {
        const currentYear = (new Date()).getFullYear()
        MONTH_OPTIONS.forEach((monthName, monthIndex) => {
          let total = 0
          const month = `${monthIndex + 1}`.padStart(2, '0')
          this.dateAnswers.forEach(dateAnswer => {
            if (dateAnswer.slice(0, 6) === `${currentYear}${month}`) {
              total += this.document.answers[dateAnswer].length
            }
          })
          data.push(total)
        })
      } else {
        const monthIndex = MONTH_OPTIONS.findIndex(i => i === this.dateItem)
        this.dateAnswers.forEach(dateAnswer => {
          if (+dateAnswer.slice(4, 6) === (monthIndex + 1)) {
            data.push(this.document.answers[dateAnswer].length)
          }
        })
      }
      return [{
        name: '',
        data,
      }]
    },
    totalAnswers() {
      // eslint-disable-next-line no-return-assign, no-param-reassign
      return this.series[0].data.reduce((total, item) => (total += item), 0)
    },
    categories() {
      if (this.selectedYear) {
        return MONTH_OPTIONS.map(i => capitalize(i))
      }
      const daysInMonth = []
      const month = MONTH_OPTIONS.findIndex(i => i === this.dateItem)
      const monthSelected = `${month + 1}`.padStart(2, '0')
      const currentYear = (new Date()).getFullYear()
      this.dateAnswers.forEach(dateAnswer => {
        if (dateAnswer.slice(0, 6) === `${currentYear}${monthSelected}`) {
          daysInMonth.push(moment(dateAnswer, 'YYYYMMDD').format('DD/MM'))
        }
      })
      return daysInMonth
    },
    chartOptions() {
      return {
        chart: {
          stacked: true,
          toolbar: {
            show: false,
          },
        },
        colors: [COLORS.PRIMARY],
        plotOptions: {
          bar: {
            columnWidth: '30%',
            endingShape: 'rounded',
            dataLabels: {
              position: 'center',
            },
          },
        },
        dataLabels: {
          enabled: true,
        },
        legend: {
          show: true,
          position: 'top',
          fontSize: '14px',
          fontFamily: 'Montserrat',
          horizontalAlign: 'left',
        },
        stroke: {
          show: true,
          colors: ['transparent'],
        },
        grid: {
          xaxis: {
            lines: {
              show: true,
            },
          },
        },
        xaxis: {
          categories: this.categories,
        },
        fill: {
          opacity: 1,
        },
      }
    },
  },
  methods: {
    dataPointSelection(event, chartContext, config) {
      let users = []
      const daysInMonth = []
      const dayIndex = config.dataPointIndex
      if (this.selectedYear) {
        const monthIndex = config.dataPointIndex
        this.dateAnswers.forEach(dateAnswer => {
          if (+dateAnswer.slice(4, 6) === (monthIndex + 1)) {
            users = [...users, ...this.document.answers[dateAnswer]]
          }
        })
      } else {
        const month = MONTH_OPTIONS.findIndex(i => i === this.dateItem)
        const monthSelected = `${month + 1}`.padStart(2, '0')
        const currentYear = (new Date()).getFullYear()
        this.dateAnswers.forEach(dateAnswer => {
          if (dateAnswer.slice(0, 6) === `${currentYear}${monthSelected}`) {
            daysInMonth.push(dateAnswer)
          }
        })
        users = this.document.answers[daysInMonth[dayIndex]]
      }
      this.$emit('show-vote-list', users, this.document.type, daysInMonth[dayIndex])
    },
  },
}
</script>

  <style lang="scss" scoped>
  @import '@hw-ui/scss/vue/libs/vue-select.scss';
  </style>
